import { Component, AfterViewInit,ViewChild,ElementRef,Output, EventEmitter } from '@angular/core';
import { SessionManagerService } from "../services/session/session-manager.service";

declare var $;
declare var MQ;
declare var MathQuill;

@Component({
  
 selector: 'dskl-wb-algebra-tools',
  templateUrl: 'algebra-tools.component.html',
  styleUrls:["algebra.css"]
})
export class AlgebraToolsComponent implements AfterViewInit{
@Output() onTool = new EventEmitter();
@Output() onDrawMathRow = new EventEmitter();
  row = [{str: "+"},{str: "-"},{str:"\\pm"},{str: "\\cdot"},{str: "\\div"},{str: "="},{str: "\\gt"},{str: "\\lt"},{str: "\\geq"},{str: "\\leq"},{str: "x^y"},{str:"\\sqrt{x}"}, {str:"\\frac{x}{y}"},{str: "x_y"}]
  
      
  row2=[{str:"\\sin"},{str:"\\cos"},{str:"\\tan"},{str:"\\cot"},{str:"\\deg"},{str:"\\alpha"},{str:"\\beta"},{str:"\\int_{0}^{1}\\f(x)dx"},{str: "\\lim_{({x} \\rightarrow {\\inf})} \\f(x)"},{str:"\\sum_{i=0}^{n} i"}]  
maintools=[
	  {str:"\\pm", vals:[{str: "+"},{str: "-"},{str:"\\pm"},{str: "\\cdot"},{str: "\\div"},{str: "="},{str: "\\gt"},{str: "\\lt"},{str: "\\geq"},{str: "\\leq"}]}, 
	  {str: "x^y", vals: [{str: "x^y"},{str:"\\sqrt{x}"}, {str:"\\frac{x}{y}"},{str: "x_y"}]}, 
	  {str:"\\alpha", vals: [{str:"\\sin"},{str:"\\cos"},{str:"\\tan"},{str:"\\cot"},{str:"\\deg"},{str:"\\alpha"},{str:"\\beta"}]},
	  {str: "--", vals: [{str:"\\int_{0}^{1}\\f(x)dx"},{str: "\\lim_{({x} \\rightarrow {\\inf})} \\f(x)"},{str:"\\sum_{i=0}^{n} i"}]}] 
arrr=[
{"name": "Operators",  "vals": ["\\pm", "\\div"]},
{"name": "Relations",  "vals": ["\\le", "\\ge"]}
]
  public commands = [
        { "name": "Operators", "tools": ["\\pm", "\\div", "\\dfrac{1}{2}", "\\sqrt{x}", "\\sqrt[n]{x}", "a^x", "a_0", "\\oslash", "\\cap", "\\cup", "\\vec{\j}", "\\infty"] },
        { "name": "Relations", "tools": ["\\le", "\\ge", "\\neq", "\\sim", "\\ll", "\\gg", "\\simeq", "\\subset", "\\supset", "\\approx", "\\equiv", "\\in", "\\ni", "\\parallel", "\\perp"] },
        { "name": "Greek", "tools": ["\\alpha", "\\beta", "\\gamma", "\\delta", "\\epsilon", "\\varepsilon", "\\zeta", "\\eta", "\\theta", "\\vartheta", "\\iota", "\\kappa", "\\lambda", "\\mu", "\\nu", "\\xi", "\\pi", "\\varpi", "\\rho", "\\varrho", "\\sigma", "\\varsigma", "\\tau", "\\upsilon", "\\phi", "\\varphi", "\\chi", "\\psi", "\\omega"] },
        { "name": "GreekCapitals", "tools": ["\\Gamma", "\\Delta", "\\Theta", "\\Lambda", "\\Xi", "\\Pi", "\\Sigma", "\\Upsilon", "\\Phi", "\\Psi", "\\Omega"] },
        { "name": "Arrows", "tools": ["\\leftarrow", "\\rightarrow", "\\leftrightarrow", "\\uparrow", "\\downarrow", "\\updownarrow", "\\nearrow", "\\searrow", "\\swarrow", "\\nwarrow", "\\Leftarrow", "\\Rightarrow", "\\Leftrightarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow"] },
        //  { "name": "Brackets", "tools": ["\\left(", "\\right)" ,"\\{", "\\}", "\\|", "\\backslash", "\\lfloor", "\\rfloor", "\\lceil", "\\rceil", "\\langle", "\\rangle", "\\underbrace{a_0+a_1+a_2+\\cdots+a_n}_{x}]"] },
        { "name": "Multiline", "tools": ["\\bigcap", "\\bigcup", "\\bigsqcup", "\\bigvee", "\\bigwedge", "\\bigodot", "\\bigotimes", "\\bigoplus", "\\biguplus"] },
        { "name": "Trigonometry", "tools": ["\\sin", "\\cos", "\\tan", "\\cot", "\\arcsin", "\\arccos", "\\arctan", "\\arccot"] },
        { "name": "Functions", "tools": ["\\partial", "\\int", "\\int^5_1", "\\oint", "\\sum_{i=1}^{\\infty}", "\\prod_{n=1}^5", "\\coprod_{n=1}^5", "\\sum_{i=1}^{\\infty}\\frac{1}{i}", "\\prod_{n=1}^5\\frac{n}{n-1}", "\\lim_{x\\to\\infty}\\frac{1}{x}", "\\binom{9}{3}"] }
    ]
@ViewChild('mathTools') rowsEl: ElementRef;
currentToolIndex=0;
fix(s){

}
 constructor( public sessionManager: SessionManagerService) {
    
  }
geometryOpened(){
	for (let b of this.sessionManager.boards)
	if (b.wbType=="GEOMETRY")return true;
	return false;
}
drawMathRow(){
this.onDrawMathRow.emit();
}
selectTool(index){
	this.currentToolIndex = index;
console.log("Selecting tool")
	setTimeout(function(){
	var MQ = MathQuill.getInterface(2);
	$('.commands').each(function() { 
		var r = MQ.StaticMath(this);
		//console.log("Setting mathquill"+this.text());
		//r.write(this.text());
	});
	}, 0);
}
clicked(w, r){

  this.onTool.emit({str: w});
  
}
ngAfterViewInit(){

		    			
		    			var h =$(this.rowsEl.nativeElement);
		    			console.log(h);
		    			h.css("left", $("body").width()-100-h.width()+90);
		    			h.css("top", $("body").height()-h.height()-48);
		    			/*h.draggable({
		    				cursor: "drag"
		    			});*/
              var MQ = MathQuill.getInterface(2);
		    			$('.tools span').each(function() { var r = MQ.StaticMath(this); });
		    			/*$(".tools").click(function(e){
		    				var w = $($(e.currentTarget).children()[0]).data("str");
		    				WbMath._writeInCurrentRow(w);
		    				WbMath.changed(w);
		    				
		    			});*/
						this.selectTool(0);
}
 }



// WEBPACK FOOTER //
// /app/src/app/wb/algebra/algebra-tools.component.ts